import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon, ArrowRightIcon } from '@heroicons/react/24/outline';
import Header from './app/Header';
import Footer from './app/Footer';
import FooterCopyright from './app/FooterCopyright';
import { CONTACT_EMAIL } from './utils/product';

const ProcessPayment = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <section className="relative overflow-hidden bg-white">
        <div className="absolute inset-0 bg-mesh-light" aria-hidden="true" />
        <div className="relative container mx-auto px-4 lg:px-6 py-20 lg:py-28">
          <div className="max-w-xl mx-auto text-center">
            <div className="h-16 w-16 mx-auto rounded-3xl bg-brand-gradient text-white flex items-center justify-center shadow-glow">
              <ClockIcon className="h-8 w-8" />
            </div>
            <h1 className="mt-6 font-display text-display-lg text-ink-900">
              Assinatura sob contratação
            </h1>
            <p className="mt-4 text-lg text-ink-500">
              Os planos Fretz Empresas (Diário, Semanal e Mensal) são ativados
              com a equipe comercial. Envie o formulário ou escreva para {CONTACT_EMAIL}.
            </p>

            <div className="mt-8 flex flex-wrap gap-3 justify-center">
              <Link to="/#contato" className="btn-primary">
                Quero Fretz Empresas
                <ArrowRightIcon className="h-4 w-4" />
              </Link>
              <Link to="/precos" className="btn-secondary">
                Ver planos
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <FooterCopyright />
    </div>
  );
};

export default ProcessPayment;
